import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Subject } from 'rxjs';
import { Confirmation } from '../models/confirmation.model';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationService {
  private confirmation$ = new BehaviorSubject<Confirmation | undefined>(undefined);

  private answer$ = new Subject<boolean>();

  private show(confirmation: Confirmation) {
    this.confirmation$.next(confirmation);
  }
  private hide() {
    this.confirmation$.next(undefined);
  }

  public observe() {
    return this.confirmation$.asObservable();
  }

  public accept() {
    this.answer$.next(true);
    this.hide();
  }

  public cancel() {
    this.answer$.next(false);
    this.hide();
  }

  public async confirm(confirmation: Confirmation) {
    this.show(confirmation);
    return await firstValueFrom(this.answer$);
  }
}
